import secretCall from '@/components/basicSetting/commonView/subComponents/secretCall.vue'
import callWaiting from '@/components/basicSetting/commonView/subComponents/callWaiting.vue'
import {collapseInit} from '@/util/collapseScript.js';

import basicSettingApi from '@/api/basicSetting/basicSettingApi'
const service = {
	secretCall: { 
		title: '去話保密', 
		description: '當您撥電話給對方時，可以選擇不顯示電話號碼於對方的手機或話機幕上。系統預設的值為將您電話號碼顯示在對方手機或話機上。', 
		serviceID: 'CNIR',
		/**此頁面有限定權限 */
		constraint: ['9'],
	},
	callWaiting: { 
		title: '話中插接', 
		description: '您可以在通話中接聽新的來電，並隨時在原通話與新的來電間作切換。當您忙線中，如果有任何電話打進，則會有特別聲響告知有電話插撥，您可選擇是否接聽。', 
		serviceID: 'CWT',
		/**此頁面有限定權限 */
		constraint: ['9'],
	},
	limitOut: { 
		title: '撥打國際電話', 
		description: '您可以利用此功能限制您的門號外撥所有國際電話。', 
		serviceID: 'INTL',
	},
	limitInside: { 
		title: '撥打付費電話', 
		description: '您可以利用此功能限制您的門號外撥所有付費電話(0209/0204/0509等)。', 
		serviceID: 'PAYP',
	},
	mobileDatingShortCode: { 
		title: '撥打行動交友簡碼', 
		description: '您可以利用此功能限制您的門號外撥交友服務簡碼(521/525/526/530/567/569/585/595/616/747/775/52990/57678/5512/55169/55199/55449/55816)', 
		serviceID: 'MFSC',
	},
}
export default {
	name: 'common-view',
	mixins: [],
	extends: {},
	components: {secretCall, callWaiting},
	props: ['service'],
	data() {
		return {
			applyStatus: 'A',
			status: null,
			seviceSelect: null,
		};
	},
	computed: {},
	watch: {
		service: function(){
			this.init();
		}
	},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init(){
			collapseInit();
			this.seviceSelect = service[this.service];
			// 若非正確網址跳轉404
			if(!this.seviceSelect){
				this.$router.push({ name: 'gt-error-404'});
				return;
			}
			// 檢查contractStatus是否有限制
			if(this.seviceSelect.constraint && !this.seviceSelect.constraint.includes(this.$store.state.profile.contractStatus)){
				this.$router.push({name: 'gt-warn', params: { msg: '很抱歉！您登入的身分不適用此功能。', title: this.seviceSelect.title, returnName: 'function-list' }})
				return;
			}
			// 初始化applyStatus
			this.status = await basicSettingApi.getVoiceBasicStatus(this.seviceSelect.serviceID, this.service);
			
		},
		async confirmVoiceBasicStatus(){
			// 前端表單驗證
			if(this.status == this.applyStatus){
				$("#myModal").modal('show');
				return;
			}
			let result = await basicSettingApi.changeVoiceBasicStatus(this.applyStatus, this.seviceSelect.serviceID, this.service);
			// 若change成功，轉至success頁面
			if(result){
				this.$router.push({name: 'common-view-result', params: { title: this.seviceSelect.title}});
			}
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/basicSetting/commonView/commonView.js